<div
  [ngClass]="{
    hidden: isMicroappMode(),
    block: !isMicroappMode(),
  }"
  class="w-full z-20 fixed py-3 lg:py-4 px-4 lg:px-6 bg-white shadow-[0_8px_16px_0_rgba(0,0,0,0.25)]"
>
  <div class="flex justify-between items-center gap-10">
    <p class="lg:hidden text-lg text-walden-500" (click)="showBottomSheet()">
      <wu-icon name="hamburgerIcon" />
    </p>
    <img
      class="h-5 lg:h-8"
      src="images/my_walden_university_logo.png"
      alt="my_walden university logo"
    />
    <!-- <div class="hidden lg:flex justify-center items-center w-full">
      <div class="w-[35rem]" embedMicroapp appName="global-search"></div>
    </div> -->
    <!-- header -->
    @if (isDesktop()) {
      <div class="hidden lg:flex justify-center items-center w-full">
        <div
          class="w-[35rem] relative"
          embedMicroapp
          appName="global-search"
        ></div>
      </div>
    }
    <div
      class="flex shrink-0 items-center gap-3 md:gap-6 text-lg text-walden-500"
    >
      <a
        href="https://outlook.office.com/"
        target="_blank"
        class="relative inline-flex items-center cursor-pointer"
        [attr.title]="
          'Email inbox: ' +
          inboxCount() +
          ' unread message' +
          (inboxCount() === 1 ? '' : 's')
        "
        [attr.aria-label]="
          'Email inbox, ' +
          inboxCount() +
          ' unread message' +
          (inboxCount() === 1 ? '' : 's')
        "
      >
        <wu-icon name="emailIcon" />
        @if (inboxCount() > 0) {
          <span
            class="absolute -top-1.5 -right-2 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-walden-300 px-[0.2rem] text-[0.625rem] font-semibold leading-none text-white"
          >
            {{ inboxCount() }}
          </span>
        }
      </a>
      <!-- <p
        class="relative inline-flex items-center cursor-pointer"
        aria-label="Notifications"
      >
        <wu-icon name="notificationIcon" />
        @if (true) {
          <span
            class="absolute -top-1.5 -right-2 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-walden-300 px-[0.2rem] text-[0.625rem] font-semibold leading-none text-white"
          >
            53
          </span>
        }
      </p> -->
      <p (click)="userIconClick.emit()" class="lg:hidden">
        <wu-icon name="userAvatarIcon" />
      </p>
      <div
        (click)="toggleProfileMenu($event)"
        class="hidden lg:flex items-center border-l cursor-pointer border-slate-500 pl-4"
      >
        <wu-avatar />
        <wu-icon name="chevronDownIcon" class="ml-1" />
      </div>
    </div>
    @if (isProfileMenuOpen) {
      <ng-container>
        <div
          class="bg-white rounded-lg shadow-lg outline-none fixed right-4 top-16"
          (click)="$event.stopPropagation()"
        >
          <wu-profile-tray></wu-profile-tray>
        </div>
      </ng-container>
    }
  </div>
</div>
